import { SelectOptionProps } from 'shared/interface/SelectOptionProps';

export enum AttachmentModalSectionEnums {
  'Floor Plans & Elevation' = 1,
  'Appliance Specs.',
  'Lighting',
  'Misc. Documents',
  'Collaboration Attachments',
  'Snapshot',
  'Manual Snapshot',
  'Acknowledgment',
  'Line Items',
  'Merged PDF',
  'Plato internal Docs.',
  'Blue Slips',
  'Exception Reports',
  'Style Conversion',
}

export enum AttachmentAlteredSections {
  'Latest Line Item Drawings' = AttachmentModalSectionEnums['Line Items'],
  'Acknowledgment' = AttachmentModalSectionEnums.Acknowledgment,
  'Latest Merged Drawings' = AttachmentModalSectionEnums['Merged PDF'],
}

export const generateAttachmentSections = () => {
  const attachmentSections = [] as SelectOptionProps[];

  Object.keys(AttachmentModalSectionEnums)
    .filter((key) => Number.isNaN(+key))
    .forEach((key) => {
      attachmentSections.push({
        label:
          AttachmentModalSectionEnums[
            AttachmentModalSectionEnums[
              key as keyof typeof AttachmentModalSectionEnums
            ]
          ],
        value:
          AttachmentModalSectionEnums[
            key as keyof typeof AttachmentModalSectionEnums
          ].toString(),
      });
    });

  return attachmentSections;
};
